import React from "react";
import { Modal, Form, Button } from "react-bootstrap";
const SalesClearModal = ({
  showClearModal,
  setShowClearModal,
  handleClearModal,
}) => {
  return (
    <React.Fragment>
      <Modal
        as={Modal.Dialog}
        centered
        show={showClearModal}
        onHide={() => setShowClearModal(false)}
      >
        <Modal.Header>
          <Modal.Title className="h6">Remove Sales Data</Modal.Title>
          <Button
            variant="close"
            aria-label="Close"
            onClick={() => setShowClearModal(false)}
          />
        </Modal.Header>
        <Modal.Body>
          <Form.Label>
            Are you sure ? You wants to clear Sales data of this Asset.
          </Form.Label>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setShowClearModal(false)}>
            No
          </Button>
          <Button
            variant="primary"
            className="text-white ms-auto"
            onClick={handleClearModal}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default SalesClearModal;
